<template>
  <div>
    <!-- 面包屑导航 -->
    <div class="flex-spc-x fixed" style="width:100%">
      <div class="flexc-cen-x">
              <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item el-breadcrumb-item :to="{ path: '/' }"
          >首页</el-breadcrumb-item
        >
        <el-breadcrumb-item>卡项</el-breadcrumb-item>
      </el-breadcrumb>
    <el-select v-if="DianList.length>1" style="margin-left:20px;width:140px" size="mini" v-model="SelectStoresID" @change="changedian()" placeholder="门店">
           <el-option
                  v-for="item in DianList"
                  :key="item.ID"
                  :label="item.StoresName"
                  :value="item.ID">
                </el-option>
    </el-select>
      </div>
    </div>

    <el-form :inline="true" :model="formInline"  style="padding-top:30px"> 
        <div class="flex-r-x">
        <el-button
          size="mini"
          type="primary"
          icon="el-icon-plus"
          v-if="q1 == true"
          @click="handleEdit()"
          >添加卡项</el-button
        >
           <el-button size="mini" type="success" v-if="list.length > 1 && q4 == true" @click="toSort()">排序</el-button>
            <el-button size="mini" type="warning"  @click="toLook()">回收站</el-button>
      </div>

    </el-form>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="全部" name="0"><div></div></el-tab-pane>
      <el-tab-pane label="次卡（有期限）" name="1"><div></div></el-tab-pane>
      <el-tab-pane label="次卡（无限期）" name="2"><div></div></el-tab-pane>
      <el-tab-pane label="期限卡（不限次数）" name="3"><div></div></el-tab-pane>
      <el-tab-pane label="储蓄卡（无限期）" name="4"><div></div></el-tab-pane>
      <el-tab-pane label="储蓄卡（有期限）" name="5"><div></div></el-tab-pane>
      <!-- <el-tab-pane label="" name="third"></el-tab-pane> -->
      <!-- <el-tab-pane label="定时任务补偿" name="fourth"></el-tab-pane> -->
    </el-tabs>
    <el-main class="main">
        <div class="flex-xy" v-if="list.length == 0" style="margin-top:10%">
                 <img src="../../assets/zanwu.png" alt="" style="width:100px;height:100px">
                 <div style="margin-top:20px;color:#808080">暂无数据</div>
        </div>
      <div class="flexc-cen-x flexw">
        <div class="card flex-xy"   v-for="items in list" :style="{backgroundImage: 'url(' + (items.CardImgurl) + ')'}" >
          <div class="xie" v-if="items.CardType ==1 ||items.CardType ==2">
            <div class="zi" style="color: white">次卡</div>
          </div>
          <div class="xie1" v-if="items.CardType ==3">
            <div class="zi" style="color: white">期限卡</div>
          </div>
           <div class="xie3" v-if="items.CardType == 4 || items.CardType == 5">
            <div class="zi" style="color: white">储蓄卡</div>
          </div>
          <div class="top flex-spc-x">
            <div
              class="cardName color"
              style="padding-left: 25px; padding-top: 10px"
            >
              <div class="cardName1">{{items.CardName}}</div>
            </div>
            <div>
              <el-popover placement="bottom" trigger="hover">
                <div class="">
                  <div class="flexc-cen-x cursor" style="height: 30px" v-if="q2 == true"    @click="handleEdit(items)">
                    <i class="el-icon-edit"></i>
                    <div style="margin-left: 10px; color: #65a8ff">编辑</div>
                  </div>
                  <div class="flexc-cen-x cursor" style="height: 30px" v-if="items.isStop == 0 && q6 == true"    @click="tingka(items)">
                    <i class="el-icon-video-pause"></i>
                    <div style="margin-left: 10px; color: #65a8ff">批量停卡</div>
                  </div>
                  <div class="flexc-cen-x cursor" style="height: 30px" v-if="items.isStop == 1 && q6 == true"    @click="jiechu(items)">
                    <i class="el-icon-video-play"></i>
                    <div style="margin-left: 10px; color: #65a8ff">解除停卡</div>
                  </div>
                  <div class="flexc-cen-x cursor" style="height: 30px" v-if="isYYDK == 1 && q8 == true" @click="editMemberDKClick(items)">
                    <i class="el-icon-edit"></i>
                    <div style="margin-left: 10px; color: #65a8ff">编辑打卡</div>
                  </div>
                    <div class="flexc-cen-x cursor" style="height: 30px" v-if="items.CardType == 1 || items.CardType == 3 || items.CardType == 5   && q7 == true"    @click="yanqi(items)">
                    <i class="el-icon-video-play"></i>
                    <div style="margin-left: 10px; color: #65a8ff">批量延期</div>
                  </div>
                  <div  class="flexc-cen-x cursor" v-if="items.CardType == 3 && q2 == true" style="height: 30px" @click="editMemberyyszClick(items)">
                    <i class="el-icon-edit"></i>
                    <div style="margin-left: 10px; color: #65a8ff">预约限制设置</div>
                  </div>
                  <div class="flexc-cen-x cursor" v-if="q2 == true"   style="height: 30px" @click="editMemberyyJYClick(items)">
                    <i class="el-icon-edit"></i>
                    <div style="margin-left: 10px; color: #65a8ff">预约周期设置</div>
                  </div>
                  <div class="flexc-cen-x cursor" style="height: 30px" v-if="q3 == true" @click="tohui(items)">
                    <i class="el-icon-delete"></i>
                    <div style="margin-left: 10px; color: #65a8ff">删除</div>
                  </div>
                  <!-- <div class="flexc-cen-x cursor" style="height: 30px" v-if="q3 == true" @click="todel(items)">
                    <i class="el-icon-delete"></i>
                    <div style="margin-left: 10px; color: #65a8ff">删除</div>
                  </div> -->
                </div>
                <el-button
                  size="mini"
                  icon="el-icon-more"
                  circle
                  slot="reference"
                ></el-button>
              </el-popover>
          
            </div>
          </div>
          <div class="cardMain">
            <div class="shadowo">
              <div class="color" style="float: left">
                <div style="height: 30px; width: 30px"></div>
                <div class="money" style="font-size: 15px">￥{{items.SellingPrice}}</div>
              </div>
              <div class="money flex-xy" style="float: right">
                <div style="font-size: 20px" v-if="items.CardType == 1||items.CardType == 2">{{items.Kynumber}}次</div>
                <div style="font-size: 20px" v-if="items.CardType == 4||items.CardType == 5">{{items.Amount}}元</div>
                <div style="font-size: 20px" v-if="items.CardType == 3">不限次数</div>
                <div v-if="items.CardType != 2 && items.CardType != 4 "
                  style="font-size: 12px; margin-top: 5px; letter-spacing: 1px"
                >
                  有效期 {{items.daysvalue}}<span v-if="items.dayType == 1">天</span>
                  <span v-if="items.dayType == 2">月</span><span v-if="items.dayType == 3">年</span>
                </div>
                <div v-if="items.CardType == 2 ||items.CardType == 4 "
                  style="font-size: 12px; margin-top: 5px; letter-spacing: 1px"
                >
                    无期限
                </div>
              </div>
            </div>
          </div>
        </div>

     
      </div>
    </el-main>
    <el-drawer :wrapperClosable= false
      :title="title"
      :visible.sync="editFormVisible"
      :direction="direction"
      size="50%"
    >
      <el-form
        label-width="100px"
        :model="editForm"
        :rules="rules"
        ref="editForm"
        style="margin-bottom:150px"
      >
        <el-form-item label="会员卡名称:" prop="CardName">
          <el-input
            size="small"
            v-model="editForm.CardName"
            auto-complete="off"
            placeholder="请输入会员卡名称"
            style="width: 215px"
          ></el-input>
        </el-form-item>
        <el-form-item label="售卖价格:" prop="SellingPrice">
          <el-input
            size="small"
            type="Number"
            v-model="editForm.SellingPrice"
            @change="changeSel"
            auto-complete="off"
            placeholder="请输入售卖价格"
            style="width: 215px"
          ></el-input>
        </el-form-item>

        <el-form-item label="会员卡类别:" prop="CardType">
          <el-radio-group v-model="editForm.CardType">
              <el-radio :label="1">次卡（有期限）</el-radio>
              <el-radio :label="2">次卡（无限期）</el-radio>
              <el-radio :label="3">期限卡（不限次数）</el-radio>
              <el-radio :label="4">储蓄卡（无限期）</el-radio>
              <el-radio :label="5">储蓄卡（有期限）</el-radio>
            </el-radio-group>
          <!-- <el-select v-model="editForm.CardType" placeholder="请选择"  size="small">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item label="会员卡背景:">
        <div style="width:500px;display:flex;flex-wrap: wrap;">
          <div  v-for="(items,index) in imgList">
             <div class="choose flex-xy" style="margin-left:20px;margin-top:10px" v-if="editForm.CardImg == items.ID"  >
              <img :src="items.CradImg" alt="" style="width: 180px;height: 100px;">
            </div>
            <div class="choose1 flex-xy" style="margin-left:20px;margin-top:10px" v-if="editForm.CardImg != items.ID" @click="toChooseimg(items)"  >
              <img :src="items.CradImg" alt="" style="width: 180px;height: 100px;">
            </div>
          </div>

        </div>
        </el-form-item>
        <el-form-item label="可用次数:" v-if="editForm.CardType == 1 || editForm.CardType == 2" prop="Kynumber">
            <el-input v-model="editForm.Kynumber" type="number" size="small" placeholder="可用次数" style="width:100px;"></el-input>次
            <!-- <el-input-number v-model="editForm.Kynumber" :step="1" step-strictly size="small"></el-input-number> -->
        </el-form-item>
        <el-form-item label="卡上金额"  v-if="editForm.CardType == 4 || editForm.CardType == 5" size="small" prop="Amount" >
            <el-input v-model="editForm.Amount" type="number" placeholder="卡上金额" style="width:100px;"></el-input> 元
         </el-form-item>
        <el-form-item v-if="editForm.CardType != 2 && editForm.CardType != 4" label="期限类别:">
            <el-radio-group v-model="editForm.dayType">
              <el-radio :label="1">天</el-radio>
              <el-radio :label="2">月</el-radio>
              <el-radio :label="3">年</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="期限值:" v-if="editForm.CardType != 2 && editForm.CardType != 4" prop="Kynumber">
              <el-input-number v-model="editForm.daysvalue" :step="1" step-strictly size="small"></el-input-number>
              <span style="margin-left:5px" v-if="editForm.dayType == 1">天</span>
              <span style="margin-left:5px" v-if="editForm.dayType == 2">月</span>
              <span style="margin-left:5px" v-if="editForm.dayType == 3">年</span>
        </el-form-item>
        <!-- <el-form-item label="有效天数:" prop="yxdays">
          <el-input
            size="small"
            v-model="editForm.yxdays"
            auto-complete="off"
            placeholder="请输入有效天数"
            style="width: 215px"
          ></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="有效金额:" prop="Amount">
          <el-input
            size="small"
            v-model="editForm.Amount"
            auto-complete="off"
            placeholder="请输入有效金额"
            style="width: 215px"
          ></el-input>
        </el-form-item> -->

        <el-form-item label="线上购买:" v-if="IsPay == 1 && hyIsPay == 1">
            <el-radio-group v-model="editForm.isBuy">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="优惠类别:" v-if="editForm.isBuy == 1">
            <el-radio-group v-model="editForm.preferentialType" @change="change">
              <el-radio :label="0">无</el-radio>
              <el-radio :label="1">减免</el-radio>
              <el-radio :label="2">打折</el-radio>
            </el-radio-group>
        </el-form-item>
        <el-form-item label="减免金额:"  v-if="editForm.preferentialType== 1 && editForm.isBuy == 1">
           <el-input
            size="small"
            v-model="editForm.preferentialvalue"
            auto-complete="off"
            placeholder="请输入优惠金额"
            style="width: 100px"
          ></el-input> 元
        </el-form-item>
        <el-form-item label="折扣:" v-if="editForm.preferentialType == 2  && editForm.isBuy == 1">
           <el-input
            size="small"
            v-model="editForm.preferentialvalue"
            auto-complete="off"
            placeholder="请输入折扣"
            style="width: 100px"
          ></el-input> %
        </el-form-item>
        <el-form-item label="线上售卖价格:" prop="preferentialAmount" v-if=" editForm.isBuy == 1">
          <div v-if="editForm.preferentialType == 0">{{editForm.SellingPrice}}</div>
          <div v-if="editForm.preferentialType == 1">{{(editForm.SellingPrice - editForm.preferentialvalue).toFixed(2)}}元</div>
          <div v-if="editForm.preferentialType == 2">{{(editForm.SellingPrice * editForm.preferentialvalue/100).toFixed(2)}}元</div>
        </el-form-item>
        <el-form-item label="激活类型:"  v-if=" editForm.isBuy == 1">
            <el-radio-group v-model="editForm.isjh" >
              <el-radio :label="0">购买成功立即激活</el-radio>
              <el-radio :label="1">首次预约激活</el-radio>
             
            </el-radio-group>
        </el-form-item>
        <el-form-item label="购买须知:" prop="Info" v-if=" editForm.isBuy == 1">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入购买须知"
            v-model="editForm.Info"
            style="width:300px"
          ></el-input>
        </el-form-item>
                <el-form-item label="备注:" prop="Note">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入备注"
            v-model="editForm.Note"
            style="width:300px"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="demo-drawer__footer flex-r-x" style="width: 50%">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          style="margin-right: 20px"
          size="small"
          type="primary"
          @click="submitForm('editForm')"
          >保存</el-button
        >
      </div>
    </el-drawer>
    <el-drawer :wrapperClosable= false title="排序" :visible.sync="sortSure" :direction="direction" size="30%" >
      <div style="width:100%;height:80vh;">
        <div v-if="keydata" v-for="(item,index) in list" class="heng flex-xy" style="width:80%" :key="item.sort">
          <div class="flex-spc-x" style="width:99%">
            <div class="flexc-cen-x" style="width:60%">
              <img :src="item.CardImgurl"  style="width:90px;height:36px" alt="">
              <!-- <img v-if="item.HeadUrl =='' " src="../../assets/img/head.png" style="width:40px;height:40px;border-radius:100%" alt=""> -->
                <div style="font-size:15px;margin-left:5px;white-space: nowrap;text-overflow:ellipsis;overflow: hidden;">{{item.CardName}}</div>
            </div>
            <div>
              <el-button v-show="index !=0" size="mini" icon="el-icon-top"  type="primary" plain @click="toTop(item)">升序</el-button>
              <el-button  v-show="index != list.length - 1 " size="mini" icon="el-icon-bottom" type="success" plain @click="toDown(item)">降序</el-button>
            </div>
          </div>
        </div> 
    </div>

      <div class="demo-drawer__footer flex-r-x" style="width:30%">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
            @click="closeDialog"
            >确定</el-button
          >
      </div>
    </el-drawer>
    <el-dialog title="停卡" :visible.sync="mainShow" width="40%" >
        <el-form>
          <el-form-item label="会员卡名称：">
                <span>{{items.CardName}}</span>
          </el-form-item>
          <el-form-item label="停卡开始日期：" prop="stopDate">
                          <el-date-picker
                          size="small"
                              v-model="stopDate"
                              align="right"
                                
                              type="date"
                              value-format="yyyy-MM-dd"
                              placeholder="请选择停卡日期">
                          </el-date-picker>
                          <div class="set-police"  >
                          &nbsp;&nbsp;
                          <span style="color: rgb(255, 117, 25);">停卡后,会员卡将暂停使用。解除停卡后启用。</span>
                        </div>
          </el-form-item>
          <el-form-item label="停卡类型："  >
                     <el-radio-group v-model="isStopType" >
                                <el-radio label="1">固定日期</el-radio>
                                <el-radio label="0">无固定日期</el-radio>
                      </el-radio-group> 
                   </el-form-item> 
                   <el-form-item label="停卡天数："  v-if="isStopType==1" prop="StopDays" >
                        <el-input v-model="StopDays" placeholder="天数" style="width:100px;"></el-input> 天
                    </el-form-item> 
          <el-form-item label="备注：" prop="Note" style="width:90%">
            <el-input type="textarea" v-model="Note"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="mainShow = false">取消</el-button>
            <el-button size="small" type="primary" :loading="loading"  @click="sure1()">确认</el-button>
        </div>
    </el-dialog>
    <el-dialog title="解除停卡" :visible.sync="jieShow" width="40%" >
        <el-form>
          <el-form-item label="会员卡名称："  >
             <span>{{items.CardName}}</span>
          </el-form-item>
          <el-form-item label="停卡日期：" prop="StopTime">
             <span>{{items.StopTime}}</span>
          </el-form-item>
          <el-form-item label="停卡天数：" prop="StopTime">
             <span>{{items.stopDays}}</span>
          </el-form-item>
          <el-form-item label="解除日期：" prop="StopTime">
             <span>{{items.kaiOverdueTime}}</span>
          </el-form-item>
          <el-form-item label="备注：" prop="Note" style="width:90%">
            <el-input type="textarea" v-model="Note"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="jieShow = false">取消</el-button>
            <el-button size="small" type="primary" :loading="loading"  @click="sure2()">确认</el-button>
        </div>
    </el-dialog>
    <el-dialog title="批量延期" :visible.sync="yanqiShow" width="40%" >
        <el-form>
          <el-form-item label="会员卡名称：">
                <span>{{items.CardName}}</span>
          </el-form-item>
           <el-form-item label="延期天数:">
           <el-input
            size="small"
            v-model="days"
            auto-complete="off"
            placeholder="请输入延期天数"
            style="width: 100px"
          ></el-input>天
           </el-form-item>
         <el-form-item label="已过期是否延期:">
            <el-radio-group v-model="isyqgq" >
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="备注：" prop="Note" style="width:90%">
            <el-input type="textarea" v-model="Note"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="yanqiShow = false">取消</el-button>
            <el-button size="small" type="primary" :loading="loading"  @click="sureYQ()">确认</el-button>
        </div>
    </el-dialog>
     <el-drawer :wrapperClosable= false
        title="回收站"
        :visible.sync="huishow"
        :direction="direction"
        size="50%"
      >
    <el-table  :data="huiList" size="small" highlight-current-row v-loading="loading"   element-loading-text="拼命加载中" style="width: 100%;margin-top:10px">
        <el-table-column  prop="CardName" label="会员卡名称">
        </el-table-column>
        <el-table-column align="center" label="会员卡类型" >
          <template slot-scope="scope">
            <span v-if="scope.row.CardType == 1">次卡（有期限）</span>
            <span v-if="scope.row.CardType == 2">次卡（有期限）</span>
            <span v-if="scope.row.CardType == 3">次卡（无限期）</span>
            <span v-if="scope.row.CardType == 4">储蓄卡（无限期）</span>
            <span v-if="scope.row.CardType == 5">储蓄卡（有期限）</span>
          </template>
      </el-table-column>
          <el-table-column align="center" prop="SellingPrice" label="会员卡价格">
        </el-table-column>
      <el-table-column align="center" label="有效期" >
          <template slot-scope="scope">
                <div v-if="scope.row.CardType != 2 && scope.row.CardType != 4 "
               
                >
               {{scope.row.daysvalue}}<span v-if="scope.row.dayType == 1">天</span>
                  <span v-if="scope.row.dayType == 2">月</span><span v-if="scope.row.dayType == 3">年</span>
                </div>
                <div v-if="scope.row.CardType == 2 ||scope.row.CardType == 4 "
               
                >
                    无期限
                </div>
          </template>
      </el-table-column>
        <el-table-column  prop="UpdTime" label="回收时间" align="center" >
        
        </el-table-column>

      <el-table-column align="center" label="操作" width="200" >
        <template slot-scope="scope">
         <el-button size="mini" type="warning" @click="toyuan(scope.row)">还原</el-button>
          <el-button size="mini" type="info" @click="todel(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
     </el-drawer>
     <el-dialog title="编辑打卡" :visible.sync="DKShow" width="40%" >
        <el-form>
          <el-form-item label="是否允许打卡：" prop="isDK">
                        <el-radio-group v-model="isDK">
                            <el-radio label="0">否</el-radio>
                            <el-radio label="1">是</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="isDK==1 && (CardType==1 || CardType==2)" label="扣除次数：" prop="DKvalue">
                             <el-input v-model="DKvalue" placeholder="扣除次数" style="width:100px;"></el-input> 次
                    </el-form-item>
                   <el-form-item v-if="isDK==1 && CardType==3" label="每周打卡次数：" prop="DKvalue">
                   <el-input v-model="DKvalue" placeholder="打卡次数" style="width:100px;"></el-input> 次

                    </el-form-item>
                    <el-form-item v-if="isDK==1 && (CardType==4 || CardType==5)" label="扣除金额：" prop="DKvalue">
                       <el-input v-model="DKvalue" placeholder="扣除金额" style="width:100px;"></el-input> 元
          </el-form-item> 
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="DKShow = false">取消</el-button>
            <el-button size="small" type="primary"   @click="submitDKForm()">确认</el-button>
        </div>
      </el-dialog>
      <el-dialog :title="yyJYtitle" :visible.sync="yyZYShow" width="40%" >
        <el-form>
                    <el-form-item label="不可预约周期：" prop="Cycle"  >
                        <el-checkbox-group v-model="checkedCycles" @change="handleChange">
                            <el-checkbox v-for="item in CycleList" :label="item.Id" :key="item.index" name="Cycle">
                                {{item.Label}}
                            </el-checkbox>
                        </el-checkbox-group>

                    </el-form-item>
           
                    <el-form-item label="是否更新：" prop="weekdaysType">
                        <el-radio-group v-model="weekdaysType">
                            <el-radio label="0">不更新</el-radio>
                            <el-radio label="1">更新已发卡</el-radio>
                        </el-radio-group>
                        <div class="inputSubLabel">不更新：代表只针对接下来新发卡客户有效 </div>
                        <div class="inputSubLabel">更新已发卡：代表已持有该卡的客户会更新成该设置 </div>

                    </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="yyZYShow = false">取消</el-button>
            <el-button size="small" type="primary"   @click="submityyJYForm()">确认</el-button>
        </div>
      </el-dialog>
      <el-dialog :title="yycstitle" :visible.sync="yycsShow" width="40%" >
        <el-form>

          
                 <el-form-item label="限制类型：" prop="isweekdaysType">
                    <el-radio-group v-model="isweekdaysType">
                            <el-radio label="1">日</el-radio>
                            <el-radio label="2">周</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    <el-form-item  label="限制最大预约次数：" prop="weekdays">
                             <el-input v-model="weekdays" placeholder="预约次数" style="width:100px;"></el-input> 次
                    </el-form-item>
           
                    <el-form-item label="是否更新：" prop="weekdaysType">
                        <el-radio-group v-model="weekdaysType">
                            <el-radio label="0">不更新</el-radio>
                            <el-radio label="1">更新已发卡</el-radio>
                        </el-radio-group>
                        <div class="inputSubLabel">不更新：代表只针对接下来新发卡客户进行预约限制 </div>
                        <div class="inputSubLabel">更新已发卡：代表已持有该卡的客户会更新成该设置 </div>

                    </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="yycsShow = false">取消</el-button>
            <el-button size="small" type="primary"   @click="submityycsForm()">确认</el-button>
        </div>
      </el-dialog>
  </div>
</template>

<script>
import { deptList, deptSave, deptDelete } from "../../api/userMG";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      CycleList:[
                    {Id:"1",Label:"周一"},
                    {Id:"2",Label:"周二"},
                    {Id:"3",Label:"周三"},
                    {Id:"4",Label:"周四"},
                    {Id:"5",Label:"周五"},
                    {Id:"6",Label:"周六"},
                    {Id:"7",Label:"周日"}
                ],
                checkedCycles:[],
                yyJYtitle:"",
                yyZYShow:false,
                JYCycle:"",
                weekdaysType:"0",
      options: [
        {
          value: "1",
          label: "次卡（有期限）",
        },
        {
          value: "2",
          label: "次卡（无限期）",
        },
        {
          value: "3",
          label: "期限卡（不限次数）",
        },
        {
           value:"4",
           label:"储蓄卡（无限期）"
        },
         {
           value:"5",
           label:"储蓄卡（有期限）"
        },
      
      ],
      DianList:[],
      Note:'',
      isyqgq:1,
      SelectStoresID:localStorage.getItem("StoresID"),
      timer:'',
      keydata:true,
      sortSure:false,
      jieShow:false,
      activeName:'0',
      value: "",
      direction: "ltr",
      formValidate: {},
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "添加",
      IsPay:localStorage.getItem("IsPay"),
      hyIsPay:localStorage.getItem("hyIsPay"),
      spIsPay:localStorage.getItem("spIsPay"),
      gkIsPay:localStorage.getItem("gkIsPay"),
      hdIsPay:localStorage.getItem("hdIsPay"),
      xmIsPay:localStorage.getItem("xmIsPay"),
      isYYDK:localStorage.getItem("isYYDK"),
      WZYGName:'',
      mainShow:false,
      WZHYName:'',
      WZXMName:'',
      WZPBName:'',
      items:{},
      isDK:"",
      DKvalue:"",
      CardType:"",
      editForm: {
        CardName:'',
        SellingPrice:0,//售卖价格
        CardType:'1',
        Kynumber:1,//可用次数
        yxdays:0,//有效天数
        Amount:0,//有效金额
        CardImg:1,//会员卡图片
        isBuy:0,//是否线上购买
        dayType:1,//期限类别  1 天 2 月 3 年
        isjh:0,//激活类型
        preferentialType:0,//优惠类别
        preferentialvalue:0,//优惠金额 或者折扣
        preferentialAmount:'',//售卖价格
        info:'',//购买须知
        daysvalue:1,//期限值
      },
      imgList:[],
      // rules表单验证
      rules: {
        CardName: [
          { required: true, message: "请输入会员卡名称", trigger: "blur" },
        ],
    
        
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: "",
        varName: "",
        token: localStorage.getItem("logintoken"),
      },
      Limits:[],
      q1:false,
      q2:false,
      q3:false,
      q4:false,
      q5:false,
      q6:false,
      q7:false,
      q8:false,
      DKShow:false,
      stopDate:'',
      days:1,
      isStopType:'1',
       StopDays:'7',
      huiList:[],
      huishow:false,
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      yanqiShow:false,
      yycstitle:'预约限制设置',
      weekdays:"0", 
      isweekdaysType:"2", 
      yycsShow:false,
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZXMName')
    this.WZPBName = localStorage.getItem('WZPBName')
    if(localStorage.getItem('isAdmin') == 1){
          this.q1 = true
          this.q2 = true
          this.q3 = true
          this.q4 = true
          this.q5 = true
          this.q6 = true
          this.q7 = true
          this.q8 = true

          
          
      }
    this.Limits = localStorage.getItem('Limits')
    this.Limits = this.Limits.split(',')
    this.Limits.forEach(items => {
          if(items == 812){
            this.q1 = true
          }
          if(items == 813){
            this.q2 = true
          }
          if(items == 814){
            this.q3 = true
          }
           if(items == 815){
            this.q4 = true
          }
          if(items == 8224){
            this.q5 = true
          }
          if(items == 816){
            this.q6 = true
          }if(items == 817){
            this.q7 = true
          }if(items == 818){
            this.q8 = true
          }
 

          
         
   })
   
    this.getList()
    this.getImg()
    this.getDianList()

  },

  /**
   * 里面的方法只有被调用才会执行
   */

  methods: {
    toLook(){

      var data = { 

        SelectStoresID:this.SelectStoresID,        
        token: localStorage.getItem("token"),
        StoresID:localStorage.getItem("StoresID"),
        CardType:0,
        
      }
      
      var that = this
      this.ajax('getListMemberCardHS.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
          res.data.forEach(items => {
                    items.UpdTime = items.UpdTime.replace(/\//g, '-')
                });
              that.timer = new Date().getTime()
              that.huiList= res.data
              that.huishow = true

          } 
       })
    },
    sureYQ(){
       var data = { 
         SelectStoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          CardID:this.items.ID,
          sourceID:localStorage.getItem("LoginID"),
          sourceName:localStorage.getItem("Name"),
          isyqgq:this.isyqgq,
          yqDays:this.days,
          yqNote:this.Note,

      }
        var that = this
       this.ajax('editMemberCardisPLYQ.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$confirm('延期成功', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {

                      that.yanqiShow = false 

                    }).catch(() => {


                        
                    });
                 
            
            }

      })
    },
    yanqi(items){
      this.items = items
      this.isyqgq = 1
      this.days = 1
      this.yanqiShow = true
    },
    changeSel(){
      this.editForm.Amount = this.editForm.SellingPrice
    },
    sure1(){
      if(this.stopDate == ''){
          this.$message({    
                message: "请选择停卡日期",
          });
        return
      }

        const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        
       var data = { 
         SelectStoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          CardID:this.items.ID,
          sourceID:localStorage.getItem("LoginID"),
          StopTime:this.stopDate,
          sourceName:localStorage.getItem("Name"),
          Note:this.Note,
          isStopType:this.isStopType,
          StopDays:this.StopDays,
      }
        var that = this
       this.ajax('editMemberCardisStop.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$confirm('停卡成功', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        
                    }).catch(() => {
                            
                    });
              that.mainShow = false
              that.getList()
              loading.close();
            }

      })
    },
    sure2(){
        const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
 
       var data = { 
         SelectStoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          CardID:this.items.ID,
          sourceID:localStorage.getItem("LoginID"),
          OverdueTime:this.items.kaiOverdueTime,
          sourceName:localStorage.getItem("Name"),
          Note:this.Note
      }
        var that = this
       this.ajax('editMemberCardOnisStop.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$confirm('解除成功', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
                        
                    }).catch(() => {
                        
                    });
                    that.jieShow = false
              that.getList()
              loading.close();
            }

      })
    },
    jiechu(items){
      this.items = items
      this.jieShow = true
      this.Note = ''

    },submityycsForm(){
      this.editMemberCardweekdays();
    }, editMemberCardweekdays(){
      var data = { SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MemberCardID:this.MemberCardID,
          weekdaysType:this.weekdaysType,
          weekdays:this.weekdays, 
          isweekdaysType:this.isweekdaysType

          }
          var that = this
          this.ajax('editMemberCardweekdays.aspx',JSON.stringify(data),"POST",function(res){

          if (res.orsuccess == "1") {
          
              that.getList()
              that.yycsShow =false;

            }

          })       
            },editMemberyyszClick(itmes){
         this.yycstitle='预约限制设置-'+itmes.CardName;
         this.MemberCardID = itmes.ID;
         this.weekdaysType= "0";
         this.weekdays =itmes.weekdays;
         this.isweekdaysType =itmes.isweekdaysType;

        
         this.yycsShow =true;
       
    },editMemberyyJYClick(itmes){
         this.yyJYtitle='预约周期设置-'+itmes.CardName;
         this.MemberCardID = itmes.ID;
         this.weekdaysType= "0";
         this.JYCycle =itmes.JYCycle;
         var arr = itmes.JYCycle.split(',');
                if(arr.length>0){
                this.checkedCycles = arr;
                }
        
         this.yyZYShow =true;
       
    },editMemberDKClick(items){
      this.items = items
      this.CardType= items.CardType;
      this.isDK= items.isDK;
      this.DKvalue= items.DKvalue;
      this.DKShow =true;

    },handleChange(val,item){
                // console.log(val)
                this.JYCycle = val.join();
                // console.log(this.ruleForm.Cycle)
            },submityyJYForm(){
      var data = { SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MemberCardID:this.MemberCardID,
          weekdaysType:this.weekdaysType,
          JYCycle:this.JYCycle, 

          }
          var that = this
          this.ajax('editMemberCardJYCycle.aspx',JSON.stringify(data),"POST",function(res){

          if (res.orsuccess == "1") {
          
              that.getList()
              that.yyZYShow =false;

            }

          })       
       },submitDKForm(){
      var data = { SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MemberCardID:this.items.ID,
          isDK:this.isDK,
          DKvalue:this.DKvalue

          }
          var that = this
          this.ajax('editMemberCardisDK.aspx',JSON.stringify(data),"POST",function(res){

          if (res.orsuccess == "1") {
          
              that.getList()
              that.DKShow =false;

            }

          })       
    },
    tingka(items){
      this.isStopType='1'
      this.StopDays='7'
      this.stopDate = '',
      this.items = items
      this.mainShow = true
      this.Note = ''
   
    },
      changedian(){
      this.pageparm ={
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      this.getList()
      this.getImg()
    },
      getDianList(){
       var data = { 
         SelectStoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID")
      }
        var that = this
       this.ajax('getListStores.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.DianList =res.data
               
            }

      })
},

    toTop(row){
      var data = { SelectStoresID:this.SelectStoresID,        

          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MemberCardID:row.ID,
    
        }
        var that = this
        this.ajax('editMemberCardDesc.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
           
              that.getList()
             
            }

        })
 
    },
    toDown(row){
      var data = { SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MemberCardID:row.ID,
    
        }
        var that = this
        this.ajax('editMemberCardAes.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
             
              that.getList()
             
            }

        })
    },
    toSort(){
          this.sortSure = true
    },
    change(){
      if(this.editForm.preferentialType == 1 ){
        this.editForm.preferentialvalue  = 0
      } 
      if(this.editForm.preferentialType == 2 ){
        this.editForm.preferentialvalue  = 100
      } 
      
    },
    toChooseimg(items){
      console.log(items)
      this.editForm.CardImg = items.ID
    },
    handleClick(){
      this.getList()
        // console.log(this.activeName)
    },
    getList(){
      var data = { SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          CardType:this.activeName
      }
      const loading = this.$loading({
              lock: true,
              text: '加载中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
      this.keydata  = false
      var that = this
      this.ajax('getListMemberCard.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
              that.timer = new Date().getTime()
                that.list= res.data
                that.keydata = true

          } 
          loading.close();

       })
    },
      getImg(){
        var data = { SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
    
      }
      var that = this
      this.ajax('getListCradImg.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
  
                that.imgList = res.data
                //  loading.close();
          } 
       })
      },
      toyuan(row){
         this.$confirm("确定要还原吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(() => {
        var data = { 
          SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MemberCardID:row.ID,
          ishuishou:0
        }
        var that = this
        this.ajax('editMemberCardishuishou.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {

              that.$message({
                type: "success",
                message: "还原",duration:2000
              });

              that.toLook()
  
            }

        })
        })
        .catch(() => {
            ;
        });
      },
    tohui(row){
       this.$confirm("确定要回收吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
        var data = { SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MemberCardID:row.ID,
          ishuishou:1
        }
        var that = this
        this.ajax('editMemberCardishuishou.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "回收成功",duration:2000
              });
           
              that.getList()
  
            }

        })
        })
        .catch(() => {
            ;
        });
   
    },
   todel(row){
       this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
        var data = { SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MemberCardID:row.ID,
        
        }
        var that = this
        this.ajax('delMemberCard.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000
              });
           
              that.toLook()
  
            }

        })
        })
        .catch(() => {
            ;
        });
   
    },
    toShow() {
      this.editFormVisible = true;
    },
    // 获取公司列表

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getList()
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
    //显示编辑界面
    handleEdit:function (row) {
      this.editFormVisible = true;
      
      if (row != undefined && row != "undefined") {
        this.title = "修改会员卡";
        this.editForm = row
        this.editForm.isBuy = Number(this.editForm.isBuy)//是否线上购买
        this.editForm.dayType = Number(this.editForm.dayType)
        this.editForm.CardType = Number(this.editForm.CardType)
        this.editForm. isjh = Number(this.editForm. isjh)
        this.editForm.preferentialType= Number(this.editForm.preferentialType)
      } else {
        this.title = "添加卡项";
        this.editForm = {
        CardName:'',
        SellingPrice:0,//售卖价格
        CardType:'1',
        Kynumber:1,//可用次数
        yxdays:0,//有效天数
        Amount:0,//有效金额
        CardImg:4,//会员卡图片
        isBuy:0,//是否线上购买
        CardType:1,
        dayType:1,//期限类别  1 天 2 月 3 年
        isjh:0,//激活类型
        preferentialType:0,//优惠类别
        preferentialvalue:0,//优惠金额 或者折扣
        preferentialAmount:'',//售卖价格
        info:'',//购买须知
      
        daysvalue:1,//期限值

      }
      
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
     this.$refs[editData].validate(valid => {
        if (valid) {
          var that = this
          var data = this.editForm
          data.SelectStoresID  = this.SelectStoresID 
            if(this.editForm.preferentialType == 0){
              this.editForm.preferentialAmount = this.editForm.SellingPrice
            }
            if(this.editForm.preferentialType == 1){
              this.editForm.preferentialAmount = this.editForm.SellingPrice - this.editForm.preferentialvalue
            }
            if(this.editForm.preferentialType == 2){
              this.editForm.preferentialAmount = this.editForm.SellingPrice * this.editForm.preferentialvalue/100
            }

            data.token=localStorage.getItem("token")
            data.StoresID=localStorage.getItem("StoresID")

            if(this.title == '添加卡项'){
              this.ajax('addMemberCard.aspx',JSON.stringify(data),"POST",function(res){
                  if (res.orsuccess == "1") {
                            that.$message({
                            type: "success",
                            message: "新建成功",duration:2000
                          });
                        that.editFormVisible = false
                        that.getList()
                      }

                  })

               

            }else {
              data.MemberCardID = this.editForm.ID
              this.ajax('editMemberCard.aspx',JSON.stringify(data),"POST",function(res){
                     if (res.orsuccess == "1") {
                              that.$message({
                                    type: "success",
                                    message: "修改成功",duration:2000
                                  });
                                  that.editFormVisible = false
                                  that.getList()
                                }                                 

                    })         

            }
        } else {
          return false
        }
      })
  
    
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deptDelete(row.deptId)
            .then((res) => {
              if (res.success) {
                this.$message({
                  type: "success",
                  message: "公司已删除!",
                });
                this.getdata(this.formInline);
              } else {
                
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("公司删除失败，请稍后再试！");
            });
        })
        .catch(() => {
            ;
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
  },
};
</script>
<style>
.el-popover{
  min-width:150px !important;
}
</style>
<style scoped>

.choose1{
  width: 194px;
  height: 114px;
  position: relative;
  cursor: pointer;
border: 1px dashed white;
  margin: -1px -8px 0;
}
.choose{
  width: 194px;
  height: 114px;
  position: relative;
  cursor: pointer;
  border: 1px dashed #409eff;
  margin: -1px -8px 0;
}
.user-search {
  margin-top: 10px;
}
.userRole {
  width: 100%;
}
.border {
  border-bottom: 1px solid #c7c7c7;
}

.popper__arrow {
  display: none !important;
}

</style>
<style scoped>
.yuan {
  float: right;
  width: 25px;
  height: 25px;

  border-radius: 100%;
}
.zi {
  position: absolute;
  margin-top: -23px;
  font-size: 14px;
  width: 45px;
  margin-left: -8px;
  transform: rotate(180deg);
}
/* rgb(231, 204, 50) */
/* rgb(240, 65, 35) */
/* #f04fe8 */
.xie3{
  position: absolute;
  left: 0;
  margin-left: -23px;
  margin-top: -110px;
  width: 30px;
  transform: rotate(135deg);
  height: 0;
  border-top: 30px solid  #2c3e50  /* rgb(240, 65, 35) */;
  border-right: 30px solid transparent;
  border-left: 30px solid transparent;
}
.xie1 {
  position: absolute;
  left: 0;
  margin-left: -23px;
  margin-top: -110px;
  width: 30px;
  transform: rotate(135deg);
  height: 0;
  border-top: 30px solid #f04fe8;
  border-right: 30px solid transparent;
  border-left: 30px solid transparent;
}
.xie {
  position: absolute;
  left: 0;
  margin-left: -23px;
  margin-top: -110px;
  width: 30px;
  transform: rotate(135deg);
  height: 0;
  border-top: 30px solid rgb(240, 65, 35);
  border-right: 30px solid transparent;
  border-left: 30px solid transparent;
}
.kuang {
  width: 80%;
  height: 35px;
  border-radius: 5px;
  border: 1px dashed #65a8ff;
}
.color {
  color: rgb(255, 255, 255);
}
.bgColor {
  background-color: rgb(186, 83, 245);
}

.color1 {
  color: rgb(253, 253, 253);
}
.bgColor1 {
  background-color: rgb(0, 204, 255);
}

.color2 {
  color: rgb(253, 253, 253);
}
.bgColor2 {
  background-color: rgb(2, 173, 53);
}

.color3 {
  color: rgb(253, 253, 253);
}
.bgColor3 {
  background-color: rgb(255, 102, 0);
}
.button {
  position: absolute;
  margin-top: 220px;

  width: 333px;
  /* width: 33.33%;
  background-color: rgb(233, 233, 233);
  height: 100%;
  border-left: 1px solid #808090;
  font-size: 18px;
  cursor: pointer; */
}

.type {
  margin-top: 15px;

  border-radius: 5px;
  height: 120px;
  width: 180px;
}
.typeTop {
  width: 100%;
  height: 60%;
}

.top {
  width: 90%;
}
.shadowo {
  width: 100%;
  /* -webkit-box-shadowo: rgb(97, 97, 97) 0px 0px 10px;
  -moz-box-shadowo: rgb(105, 105, 105) 0px 0px 10px;
  box-shadowo: rgb(78, 78, 78) 0px 0px 10px; */
}
.cardMain {
  width: 90%;
  margin-top: 12%;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.card {
  position: relative;
  margin-bottom: 80px;
  width: calc((100% - 80px) / 4);
  height: 150px;
  margin-left: 20px;
  border-radius: 20px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
@media screen and (max-width: 1400px) {
  .card {
    cursor: pointer;
    width: calc((100% - 60px) / 3);
  }
}
.cardName {
  font-size: 20px;
  width: 60%;
}
.left {
  width: 35%;
}
.cardType {
  max-width: 100%;
  white-space: nowrap; /*强制在一行显示*/
  text-overflow: ellipsis; /*设置超出内容显示...*/
  overflow: hidden; /*一定不能少 超出的内容进行隐藏*/
  color: white;
  font-size: 15px;
  border-radius: 50px;
  padding: 1px 10px 1px 10px;
}
.money {
  font-size: 18px;
  color: #dadada;
}
.cardName1 {
  max-width: 90%;
  float: left !important;
  white-space: nowrap; /*强制在一行显示*/
  text-overflow: ellipsis; /*设置超出内容显示...*/
  overflow: hidden; /*一定不能少 超出的内容进行隐藏*/
  font-size: 20px;
}
.typeDown {
  width: 100%;
  height: 40%;
}
.card1 {
  margin-left: 10px;
  position: relative;
  margin-bottom: 80px;
  width: calc((100% - 80px) / 4);
  height: 150px;
  border-radius: 20px;
  background-image: url("../../assets/bg1.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.card2 {
  margin-left: 10px;
  position: relative;
  margin-bottom: 80px;
  width: calc((100% - 80px) / 4);
  height: 150px;
  border-radius: 20px;
  background-image: url("../../assets/bg2.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.card3 {
  margin-left: 10px;
  position: relative;
  margin-bottom: 80px;
  width: calc((100% - 80px) / 4);
  height: 150px;
  border-radius: 20px;
  background-image: url("../../assets/bg3.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.main {
  /* background-color: darkgrey; */
  /* height: 100vh; */
}
.cardbg {
  margin-top: 80px;

  width: 33%;
  height: 400px;
}

.flex-xy {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.flexw {
  flex-wrap: wrap;
}
.flexc-cen-x {
  display: flex;
  align-items: center;
}
.flex-cent-x {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.flex-spc-x {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.flex-aro-x {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
</style>


// WEBPACK FOOTER //
// src/views/card/card.vue